import {IRegistrationExternalLinkHandler} from "./registration.external-link-handler.interface";
import {ExternalLinkHandlerBase} from "../external-link-handler-base";

export class RegistrationExternalLinkHandler extends ExternalLinkHandlerBase implements IRegistrationExternalLinkHandler {

}